import { Alert, message } from "antd";
import axios, { AxiosRequestHeaders, AxiosResponse } from "axios";
import { useNavigate } from "react-router-dom";
import storage from "./utils/storage";

// Function to get the token from localStorage
// const getToken = (): string | null => {
//   const token = localStorage.getItem('token');
//   return token;
// };
export const getToken = (): string | null => {
  const token = storage.get("token");
  return token;
};

// Set up the Axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "https://api.anvayaa.com",
  withCredentials: true,
});

apiClient.interceptors.request.use(
  (config: any) => {
    const token = getToken();
    if (token) {
      if (!config.headers) {
        config.headers = {} as AxiosRequestHeaders;
      }
      config.headers["token"] = token;
    }
    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  },
);

export const login = async (phoneNo: string): Promise<AxiosResponse<any>> => {
  const response = await apiClient.post("/partner/registeruser", {
    mobileNumber: phoneNo,
    type: "SignIn",
  });
  return response;
  // try {
  //   const response = await apiClient.post('/partner/registeruser', {
  //     mobileNumber: phoneNo,
  //     type: 'SignIn',
  //   });
  //   if (response.status === 200 && response.data.data.userOtpID) {
  //     const otpUserId = response.data.data.userOtpID;
  //     const userId = response.data.data.userID; // Corrected variable name
  //     const token = response.data.data.token;
  //     // alert(response.data.message);
  //     message.success(response.data.message)

  //     if (token) {
  //       storage.set('token', token);
  //       storage.set('tokenExpiresAt', (Date.now() + 8 * 60 * 60 * 1000).toString());
  //     }
  //     if (userId) {
  //       storage.set('userId', userId); // Storing userId in localStorage
  //     }
  //     return { userOtpID: otpUserId, token, userId }; // Corrected variable name in return
  //   } else if (response.status === 202) {
  //     message.info(response.data.message);
  //     return { userOtpID: '', token: undefined, userId: '' };
  //   } else {
  //     message.error(response.data.message || 'Invalid response from server');
  //     throw new Error('Invalid response from server');
  //   }
  // } catch (error: any) {
  //   throw error;
  // }
};

export const removeRateCard = async (removeService: {
  cityID: string;
  subSubCategoryID: string;
  contractID: string;
  partnerID: string;
  tarrifType: string;
}): Promise<AxiosResponse<any>> => {
  return await apiClient.put("/contract/removeRateCard", removeService);
};

export const verifyOtp = async (
  OTP: number,
  userOtpID: string,
): Promise<AxiosResponse<any>> => {
  return await apiClient.post("/partner/verifyotp", {
    OTP,
    userOtpID,
  });
};

export const register = async (
  phoneNo: string,
  partnerName: string,
  isTemporary: boolean,
): Promise<{ userOtpID: string; token?: string; response?: number }> => {
  try {
    const response = await apiClient.post("/partner/registeruser", {
      mobileNumber: phoneNo,
      type: "Joinus",
      partnerName: partnerName,
      isTemporary: isTemporary,
    });
    if (response.status === 200 && response.data.data) {
      console.log("valid response", response);
      const otpUserId = response.data.data.userOtpID;
      localStorage.setItem("partnerID", response.data.data.partnerID);
      localStorage.setItem("userID", response.data.data.userID);
      storage.set("userID", response.data.data.userID);
      storage.set("partnerID", response.data.data.partnerID);
      const token = response.data.data.token;
      // alert(response.data.message);
      message.success(response.data.message);
      // Store the token in localStorage
      if (token) {
        storage.set("token", token);
        storage.set(
          "tokenExpiresAt",
          (Date.now() + 8 * 60 * 60 * 1000).toString(),
        );
        storage.set("userId", response.data.data.userID);
      }
      return { userOtpID: otpUserId, token };
    } else if (response.status === 202) {
      console.log("no response", response);
      message.info(response.data.message);
      return { userOtpID: "", token: undefined, response: response.status };
    } else {
      message.error(response.data.message || "Invalid response from server");
      throw new Error("Invalid response from server");
    }
  } catch (error: any) {
    throw error;
  }
};

export const registerUser = async (bills: any): Promise<AxiosResponse<any>> => {
  return await apiClient.post(
    "/partner/partnerRequest/viewPartnerPayments",
    bills,
  );
};

export const getLanguages = async (
  token: string,
): Promise<AxiosResponse<any>> => {
  try {
    const response = await apiClient.get(
      "/partner/partnerProfile/getLanguages",
      {
        headers: {
          token: token,
        },
      },
    );
    return response;
  } catch (error: any) {
    console.error("Error fetching languages:", error.message);
    throw error;
  }
};
export const getAllServices = async (
  token: string,
): Promise<AxiosResponse<any>> => {
  try {
    const response = await apiClient.get(
      "/partner/partnerProfile/getAllServices",
      {
        headers: {
          token: token,
        },
      },
    );
    return response;
  } catch (error: any) {
    console.error("Error fetching languages:", error.message);
    throw error;
  }
};
export const getAllServicesAreas = async (
  token: string,
): Promise<AxiosResponse<any>> => {
  try {
    const response = await apiClient.get(
      // '/partner/partnerProfile/getAllServicesAreas',
      "/api/locations/allCities",
      {
        headers: {
          token: token,
        },
      },
    );
    return response;
  } catch (error: any) {
    console.error("Error fetching languages:", error.message);
    throw error;
  }
};
export const getAmbulanceTypes = async (
  token: string,
): Promise<AxiosResponse<any>> => {
  try {
    const response = await apiClient.get(
      "/partner/partnerProfile/getAmbulanceTypes",
      {
        headers: {
          token: token,
        },
      },
    );
    return response;
  } catch (error: any) {
    console.error("Error fetching languages:", error.message);
    throw error;
  }
};

export const getServicesTypes = async (
  token: string,
): Promise<AxiosResponse<any>> => {
  try {
    const response = await apiClient.get(
      "/partner/partnerProfile/getServicesTypes",
      {
        headers: {
          token: token,
        },
      },
    );
    return response;
  } catch (error: any) {
    console.error("Error fetching languages:", error.message);
    throw error;
  }
};

export const getPartnerProfile = async (
  partnerID?: any,
): Promise<AxiosResponse<any>> => {
  try {
    const response = await apiClient.get(
      "/partner/partnerProfile/viewPartnerProfile",
      {
        params: { partnerID },
      },
    );
    return response;
  } catch (error: any) {
    console.error("Error fetching partner profile:", error.message);
    throw error;
  }
};

export const getPartnerProfileDetails = async (
  partnerID?: any,
): Promise<AxiosResponse<any>> => {
  try {
    const response = await apiClient.get(
      "/partner/partnerProfile/viewPartnerProfiledata",
      {
        params: { partnerID },
      },
    );
    return response;
  } catch (error: any) {
    console.error("Error fetching partner profile:", error.message);
    throw error;
  }
};

export const getPartnerProfileAdmin = async (
  partnerID: string,
): Promise<AxiosResponse<any>> => {
  try {
    const response = await apiClient.get(
      "/partner/partnerProfile/viewPartnerProfile",
      {
        params: { partnerID },
      },
    );
    return response;
  } catch (error: any) {
    console.error("Error fetching partner profile:", error.message);
    throw error;
  }
};

export const createPartnerServices = async (
  selectservices: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.post(
    "/partner/partnerProfile/createPartnerServices",
    selectservices,
  );
};

export const createPartnerServicesDetails = async (
  data: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.post(
    "partner/partnerProfile/createPartnerServicesDetails",
    data,
  );
};

export const creatBnakDetails = async (
  bankdetails: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.post(
    "partner/bankdetails/createbankdetails",
    bankdetails,
  );
};

export const cityNames = async (): Promise<AxiosResponse<any>> => {
  return await apiClient.get(
    // "/partner/partnerProfile/getAllServicesAreas"
    "/api/locations/allCities",
  );
};
export const Languages = async (): Promise<AxiosResponse<any>> => {
  return await apiClient.get("/partner/partnerProfile/getLanguages");
};

export const allServices = async (): Promise<AxiosResponse<any>> => {
  return await apiClient.get("/partner/partnerProfile/getAllServices");
};

export const creatPartnerProfile = async (
  profileDetails: FormData,
): Promise<AxiosResponse<any>> => {
  return await apiClient.post(
    "/partner/partnerProfile/createPartnerProfile",
    profileDetails,
    {},
  );
};

export const adduser = async (
  AddDetails: FormData,
): Promise<AxiosResponse<any>> => {
  return await apiClient.post("/partner/adduser", AddDetails);
};
export const Religions = async (): Promise<AxiosResponse<any>> => {
  return await apiClient.get("/partner/getRequiredConstants");
};
export const partneruserdetails = async (
  usertable: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.post("/partner/getpartneruserdetails", usertable);
};

export const dashboardCounts = async (): Promise<AxiosResponse<any>> => {
  return await apiClient.get("/partner/partnerRequest/viewDashboardCount");
};

export const viewBankdetails = async (
  partnerID: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.get(
    "/partner/bankdetails/viewbankdetails?partnerID=" + partnerID,
  );
};

export const updateBankDetails = async (
  profileDetails: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.put(
    "/partner/bankdetails/updatebankdetails",
    profileDetails,
  );
};

export const viewContractFileDataPartner = async (): Promise<
  AxiosResponse<any>
> => {
  return await apiClient.get(
    "/partner/partnerProfile/viewPartnersContractFile",
  );
};

export const partnerApproveContract = async (
  contractDetails: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.put(
    "/contract/approvecontractbypartner",
    contractDetails,
  );
};

export const submitInvoice = async (
  invoiceDetails: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.post(
    "/partner/partnerRequest/generatePartnerinvoice",
    invoiceDetails,
  );
};

export const adminApproveContract = async (
  contractDetails: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.put(
    "/contract/approvecontractbypartnermanager",
    contractDetails,
  );
};

// Admin Routes

export const adminDashboard = async (): Promise<AxiosResponse<any>> => {
  return await apiClient.get("/adminDashboard/viewPartnerDashboard");
};
// export const getRateCardFilters = async (): Promise<AxiosResponse<any>> => {
//   return await apiClient.get("/contract/filters");
// };
// console.log(apiClient.defaults.baseURL + "/api/task/getRateCardFilters");
// export const getFilteredRateCards = async (payload: {
//   serviceName: string;
//   cityID: string;
//   partnerID: string;
//   page?: number;
//   limit?: number;

// }): Promise<AxiosResponse<any>> => {
//   return await apiClient.post("/contract/ratecards", payload);
// };

export const adminAllStaffView = async (
  status?: string,
): Promise<AxiosResponse<any>> => {
  const url = status
    ? `/partner/getUsers/status?userStatus=${status}`
    : "/partner/getUsers/status";
  return await apiClient.get(url);
};

export const getAllStaffOverview = async (params: {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  partnerID?: string;
  subcategoryID?: string;
}): Promise<AxiosResponse<any>> => {
  return await apiClient.post("/adminDashboard/getAllStaffOverview", params);
};

export const adminLogin = async (
  credentials: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.post("/partner/adminlogin", credentials);
};

export const getAllPartnerDetails = async (): Promise<AxiosResponse<any>> => {
  return await apiClient.get("/partner/partnerProfile/viewAllPartnerProfile");
};
export const getAllPartnerDetailsStatus = async (
  status: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.get(
    "/adminDashboard/partners?status=" +
      status.status +
      "&pageNumber=" +
      status.pageNumber +
      "&pageLimit=" +
      status.pageLimit,
  );
};

export const searchPartners = async (
  searchQuery: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.get(
    `/adminDashboard/searchbymobornames?key=${searchQuery}`,
  );
};

export const getAllContracts = async (
  type: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.get(
    "/contract/getallcontracts?status=" +
      type.status +
      "&pageNumber=" +
      type.pageNumber +
      "&pageLimit=" +
      type.pageLimit,
  );
};

export const getContractDetails = async (
  partnerID: string,
  contractID?: string,
  pageNumber?: number,
  pageLimit?: number,
): Promise<AxiosResponse<any>> => {
  const params: Record<string, string | number> = { partnerID };

  if (contractID) params.contractID = contractID;
  if (pageNumber !== undefined) params.pageNumber = pageNumber;
  if (pageLimit !== undefined) params.pageLimit = pageLimit;

  return await apiClient.get("/contract/getcontract", { params });
};

// export const getContractDetails = async (partnerID: string,contractID?: string,cityID?: number,pageLimit?:number,subSubCategoryID?:string ): Promise<AxiosResponse<any>> => {
//   return await apiClient.get(`/contract/getcontract?partnerID=${partnerID}&scroll=true&contractID=${contractID}&cityID=AKCSERCTY2&limit=${pageLimit}`);
// }

export const getContractDocument = async (
  partnerID: string,
): Promise<AxiosResponse<any>> => {
  return await apiClient.get(
    "/partner/partnerProfile/viewPartnersContractFile?partnerID=" + partnerID,
  );
};

export const fetchCategories = async (): Promise<AxiosResponse<any>> => {
  return await apiClient.get("/partner/partnerRequest/viewAllCategoryDetails");
};

export const viewSubServices = async (
  payload: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.post(
    "/partner/partnerProfile/viewservicesByID",
    payload,
  );
};

export const createContract = async (
  contractDetails: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.post("/contract/createcontract", contractDetails);
};

export const viewContractFileData = async (
  partnerID: string,
): Promise<AxiosResponse<any>> => {
  return await apiClient.get(
    "/partner/partnerProfile/viewPartnersContractFile?partnerID=" +
      partnerID.trim(),
  );
};

export const approveOrRejectPartnerDetails = async (
  approval: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.put(
    "/partner/partnerProfile/approveOrRejectByManager",
    approval,
  );
};

export const getAllPartnersContracts = async (): Promise<
  AxiosResponse<any>
> => {
  return await apiClient.get("/contract/getcontract");
};

export const getSelectedContract = async (
  contractID: string,
): Promise<AxiosResponse<any>> => {
  return apiClient.get(
    "/contract/viewPartnerContract?contractID=" + contractID,
  );
};

//////////////////////////////////////////////////////////////////////////////////////////////

export const updateuser = async (adduser: any): Promise<AxiosResponse<any>> => {
  return await apiClient.put("/partner/updateuser", adduser);
};

export const bulkReleaseStaff = async (payload: {
  userIDs: string[];
  partnerID: string;
}): Promise<AxiosResponse<any>> => {
  return await apiClient.put("/partner/bulkReleaseStaff", payload);
};

// export const viewuserdetails = async (UserID:any): Promise<AxiosResponse<any>> => {
//   return await apiClient.get('viewuserdetails'+UserID);
// };
export const viewuserdetails = async (
  userID: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.get(`/partner/viewuserdetails`, {
    params: {
      userID: userID,
    },
  });
};

export const viewpendingbills = async (
  bills: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.post(
    "/partner/partnerRequest/viewPartnerPayments",
    bills,
  );
};

//  this below function to update Bills in bill section Approve / reject
export const updatependingbills = async (
  bills: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.put(
    "/partner/partnerRequest/updatePartnerPendingBills",
    bills,
  );
};

export const newjobs = async (partnerID: any): Promise<AxiosResponse<any>> => {
  return await apiClient.get(
    "/partner/partnerRequest/viewJobRequestDetails?PartnerID=" + partnerID,
  );
};

// below api is for view request detailes for partner
export const viewrequestdetails = async (
  requestID: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.get(
    "/partner/partnerRequest/viewRequest?requestID=" + requestID,
  );
};

export const acceptedrequest = async (): Promise<AxiosResponse<any>> => {
  return await apiClient.get("/partner/partnerRequest/viewacceptRequest");
};

export const regeneratOtp = async (mobilenumber: {}): Promise<
  AxiosResponse<any>
> => {
  return await apiClient.post("/partner/regenerateOTP", mobilenumber);
};

// API call for Accept OR Reject By partner
export const acceptRequestByPartner = async (requestDetails: {}): Promise<
  AxiosResponse<any>
> => {
  return await apiClient.post(
    "/partner/partnerRequest/acceptOrRejctRequest",
    requestDetails,
  );
};
export const getStaffList = async (
  requestID: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.get(
    "/partner/partnerRequest/getStaffList?requestID=" + requestID,
  );
};
export const submitProfile = async (
  profileDetails: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.post(
    "/partner/partnerRequest/submitProfile",
    profileDetails,
  );
};
export const viewMSP = async (): Promise<AxiosResponse<any>> => {
  return await apiClient.get("/adminDashboard/viewMSP");
};

export const updateMSP = async (
  updateMsp: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.put("/adminDashboard/updateMSP", updateMsp);
};

export const viewPartnerFinanceDetails = async (
  financeDetails: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.post(
    "/partner/partnerRequest/viewPartnerFinanceDetails",
    financeDetails,
  );
};

export const viewPartnerPendinginvoice = async (
  partnerID: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.get(
    "partner/partnerRequest/viewPartnerPendinginvoice?partnerID=" + partnerID,
  );
};

export const forgetPasswoard = async (
  mobile: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.post("/partner/forgotPassword", mobile);
};

export const changePasswoard = async (
  passwordRec: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.post("/partner/changePassword", passwordRec);
};

export const partnerLogin = async (
  credentials: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.post("/partner/partnerLogin", credentials);
};

export const authStore = async (auth: any): Promise<AxiosResponse<any>> => {
  return await apiClient.post("/notifications/storeauthdata", auth);
};

export const requestsCounts = async (
  partnerID: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.get(
    "/partner/partnerRequest/getAllReportCount?PartnerID=" + partnerID,
  );
};


export const requestsTypes = async (partner: any): Promise<AxiosResponse<any>> => {
  return await apiClient.get(`/partner/partnerRequest/getOngoingCompleteJobRequestDetails?partnerID=${partner?.partnerID}&page=${partner?.page}&limit=${partner.limit}&statusType=${partner.statusType}`);
};

export const bulkStaffUpload = async (
  file: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.post("/partner/uploadfile", file);
};

export const adminUserDetails = async (): Promise<AxiosResponse<any>> => {
  return await apiClient.get("/partner/adminuserdetails");
};

export const updateRateOfRateCard = async (
  updateRates: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.put("/contract/updateratecarddetails", updateRates);
};

export const updateServiceInRateCard = async (
  addnewService: any,
): Promise<AxiosResponse<any>> => {
  return await apiClient.post("/contract/addnewService", addnewService);
};

export const terminateContract = async (params: any) => {
  return await apiClient.post("/contract/terminateContract", params);
};

export const addPointOfContact = async (payload: any) => {
  return await apiClient.post(
    "/partner/partnerProfile/addmorePOCDetails",
    payload,
  );
};

export const getInactivePointOfContact = async (partnerID: any) => {
  return await apiClient.get(
    `/partner/partnerProfile/viewInActivePOC?partnerID=${partnerID}`,
  );
};

export const updatePartnerDetails = async (payload: any) => {
  return await apiClient.post(
    "/partner/partnerProfile/updatePartnerDetails",
    payload,
  );
};

export const deletePointOfContact = async (payload: any) => {
  return await apiClient.post("/partner/partnerProfile/removePOC", payload);
};

export const duplicateAdhaarCheck = async (adharnumber: any) => {
  return await apiClient.post(
    "/partner/addUser/checkDuplicateAdhar",
    adharnumber,
  );
};

export const updateTicketStatus = async (ticket: any) => {
  return await apiClient.post("/ticket/updateTicket", ticket);
};

export const getRateCardFilters = async () => {
  return await apiClient.get("/contract/filters");
};

export const getFilteredRateCards = async (filters: any) => {
  return await apiClient.post("/contract/ratecards", filters);
};
